import './BoxBlock.scss'

import React from 'react'
import {Theme} from 'views/Theme'
import {LinkType, WysiwygType} from '../../types'
import {style} from '../../util/style'
import {Block} from './Blocks'

const styles = style('boxblock')

export type BoxBlockType = {
	markedtitle?: string
	title?: string
	text?: WysiwygType
	button?: LinkType
}

export const BoxBlock: React.FC<BoxBlockType & {container?: boolean}> = ({
	container,
	markedtitle,
	title,
	text,
	button
}) => {
	if (!title && !text && !button) return null

	return (
		<Block className={styles().mod({markedtitle})} container={container}>
			<div className={styles('content')}>
				{markedtitle && (
					<Theme.H3
						className={styles('content-markedtitle')}
						mod={['white', 'marked', 'slantleft']}
					>
						{markedtitle}
					</Theme.H3>
				)}
				{title && (
					<Theme.H2
						className={styles('content-title').mod({maxwidth: container})}
						mod="bold"
					>
						{title}
					</Theme.H2>
				)}
				{text && (
					<div className={styles('content-text')}>
						<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
					</div>
				)}
				{button?.url && (
					<div className={styles('content-button')}>
						<Theme.Button to={button.url}>
							{button.description || button.title}
						</Theme.Button>
					</div>
				)}
			</div>
		</Block>
	)
}
